import { config } from '@abyss/web/tools/config';
import { Heading } from '@abyss/web/ui/Heading';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { Text } from '@abyss/web/ui/Text';
import find from 'lodash/find';

import { useLagoon } from '../../hooks/useLagoon';
import { shouldUseGehaV2Styling } from '../../utils/gehaThemeUtils';
import { ConstantsLagoon } from '../ConstantsLagoon';
import {
  CareProviderContainer,
  CareProviderImage,
  CareTeamEmptyCardContainer,
  CareTeamEmptyCardData,
  CareTeamEmptyCardHeader,
  CareTeamEmptyCardStyle,
  CareTeamSkeleton,
} from './CareTeamEmptyState.styled';

const provider = [
  {
    name: 'John Doctor, MD',
    bookMarked: true,
    img: `${config(
      'CDN_BASE_URL'
    )}/cdn/assets/images/default_Practitioner1.png`,
  },
  {
    bookMarked: false,
    name: 'Sandra Physician, DO',
    img: `${config(
      'CDN_BASE_URL'
    )}/cdn/assets/images/default_Practitioner2.png`,
  },
];

export const CareTeamEmptyCard = () => {
  const lagoonData = useLagoon('ui-messaging')();
  const isGEHAV2 = shouldUseGehaV2Styling();

  const cardDescription = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.CARE_TEAM.CARE_EMPTY_CARD_DESCRIPTION,
  });

  return (
    <CareTeamEmptyCardContainer
      alignContent="center"
      alignItems="center"
      data-auto-testid={'care-team-empty-card'}
      data-testid={'care-team-empty-card'}
    >
      <CareTeamEmptyCardStyle>
        <CareTeamEmptyCardHeader>
          <Heading
            data-auto-testid="care-team-empty-header"
            data-testid="care-team-empty-header"
            display="h3"
            offset={0}
          >
            {cardDescription?.title}
          </Heading>
          <Text
            color={'$black30'}
            css={{ margin: '10px 0px 8px 0px' }}
            data-auto-testid="care-team-empty-description"
            data-testid="care-team-empty-description"
            size="$md"
          >
            {cardDescription?.message}
          </Text>
        </CareTeamEmptyCardHeader>
        <CareTeamEmptyCardData>
          {provider.map((item, index) => (
            <CareProviderContainer cssProps={index} key={index}>
              <IconSymbol
                color="$interactive4"
                data-auto-testid="sub-Specialities-drawer"
                data-testid="sub-Specialities-drawer"
                icon="bookmark"
                size="24px"
                variant={item.bookMarked ? 'filled' : 'outlined'}
              />

              <CareProviderImage data-testid={`care-provider-image`}>
                <img alt="img" src={item.img} style={{ borderRadius: '50%' }} />
              </CareProviderImage>
              <div>
                <Text
                  color={isGEHAV2 ? '$primary1' : '$blue'}
                  data-auto-testid="care-team-empty-text"
                  data-testid="care-team-empty-text"
                  fontWeight={700}
                  size="$md"
                >
                  {item.name}
                </Text>
                <CareTeamSkeleton
                  data-auto-testid="care-team-skeleton"
                  data-testid="care-team-skeleton"
                  size="md"
                />
                <CareTeamSkeleton
                  data-auto-testid="care-team-skeleton"
                  data-testid="care-team-skeleton"
                  size="lg"
                />
                <CareTeamSkeleton
                  data-auto-testid="care-team-skeleton"
                  data-testid="care-team-skeleton"
                  size="lg"
                />
              </div>
            </CareProviderContainer>
          ))}
        </CareTeamEmptyCardData>
      </CareTeamEmptyCardStyle>
    </CareTeamEmptyCardContainer>
  );
};
